<template>
    <v-container>
        <form-toolbar
            :canEdit="canEdit"
            :userRoles="userRoles"
            :editMode="editMode"
            :assignment="assignment"
            :field="'blowing'"
            @cancel-button-clicked="switchEditMode(false)"
            @edit-button-clicked="switchEditMode(true)"
        />
        <autopsy-info :assignment="this.assignment" :propertyTab="'blowing'"/>
        <v-form :readonly="readOnly" class="assignment-form">
            <v-card class = "form-group-fields" elevation="6">
                <div class = "second-row">
                    <custom-datetime :value="localBlowing.appointmentDate || ''" :readOnly="true" @onSelect="appointmentDateSelected"/>
                    <v-select
                        v-model="localBlowing.status"
                        :items="statuses"
                        item-value="value"
                        item-text="name"
                        label="Κατάσταση"
                        outlined
                        class="field status"
                    ></v-select>
                </div>
                <comments
                    ref="comments"
                    :comments="this.localBlowing?.comments || {}"
                    :clearable="clearable"
                    :editMode="editMode"
                    :rules="editMode ? rules: []"
                    @new-comment="onNewComment"
                />
                <material-selection v-if="config.hasStorage" ref="material-selection" :editMode="editMode" :assignmentTab="'blowing'" :assignment="assignment" />
                <image-section ref="image-section" :uploadedPhotos="this.localBlowing.photos || []" :editMode="editMode" :readOnly="readOnly" :clearable="clearable" :uploadPath="this.assignment.sr + '/blowing'" @photoSelection="onPhotoSelection" :title="'Φωτογραφίες'" :zipName="this.assignment.sr + '_' + 'blowing'" />
                <v-divider class="mt-5"/>
                <issue-existance-field
                    ref="prodesmeusi-difference-section"
                    :label="'Διαφορά από Προδέσμευση'"
                    :check="hasProdesmeusiDifference"
                    :comments="localBlowing.prodesmeusiDifference?.comments || {}"
                    :readOnly="readOnly"
                    :clearable="clearable"
                    :editMode="editMode"
                    noImages
                />
                <v-divider />
                <issue-existance-field
                    ref="malfunction-section"
                    :label="'Βλάβη / Πρόβλημα'"
                    :photoLabel="'Φωτογραφίες Βλάβης'"
                    :check="hasMalfunction"
                    :comments="localBlowing.malfunction?.comments || {}"
                    :uploadedPhotos="localBlowing.malfunction?.photos || []"
                    :readOnly="readOnly"
                    :clearable="clearable"
                    :editMode="editMode"
                    :uploadPath="this.assignment.sr + '/blowing/malfunction'"
                    @onIssuePhotoSelection="onTroublePhotoSelection"
                />
            </v-card>
            <div v-if="canEdit" class="submit-button-wrapper">
                <v-btn class="mx-2 white--text" :disabled="shouldDisableSubmit" :loading="loading" large color="black" @click="onSubmit">
                    ΥΠΟΒΟΛΗ
                </v-btn>
            </div>
        </v-form>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import assignmentService from '@/services/assignment'
    import Alert from '@/components/Alert'
    import ImageSection from '@/components/ImageSection'
    import FormToolbar from '@/components/FormToolbar'
    import geolocation from '@/utils/geolocation'
    import MaterialSelection from '@/components/MaterialSelection'
    import Comments from '@/components/Comments'
    import momentTimezone from 'moment-timezone'
    import CustomDatetime from '@/components/CustomDatetime'
    import IssueExistanceField from '@/components/IssueExistanceField'
    import AutopsyInfo from '@/components/AutopsyInfo'

    export default {
        name: 'BlowingTab',
        components: { Alert, AutopsyInfo, Comments, CustomDatetime, ImageSection, FormToolbar, MaterialSelection, IssueExistanceField },
        watch: {
            assignment: {
                handler(newVal, oldVal) {
                    this.resetForm()
                },
                deep: true
            }
        },
        props: {
            assignment: {
                type: Object,
                required: true
            },
            currentUser: {
                type: Object,
                default: () => { return {} },
                required: true
            },
            canEdit: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            userRoles() {
                return this.currentUser?.roles?.map(role => role.role) || []
            },
            shouldDisableSubmit() {
                if (this.localBlowing.status === 'FOR_CANCELLING') {
                    return false
                }
                return !(this.localBlowing.appointmentDate && (this.localBlowing.comments || this.newComment) && this.editMode)
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            statuses() {
                return this.config?.blowing?.statuses || []
            }
        },
        data: () => {
            return {
                localBlowing: {
                    description: null,
                    photos: [],
                    completed: false
                },
                hasMalfunction: false,
                hasProdesmeusiDifference: false,
                selectedTroublePhotos: [],
                showAlert: false,
                message: null,
                newComment: null,
                type: null,
                loading: false,
                selectedPhotos: 0,
                mode: null,
                readOnly: false,
                clearable: true,
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ],
                editMode: false
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'edit') {
                this.readOnly = true
                this.clearable = false
            }
            this.assignmentId = this.$route.params.assignmentId
        },
        mounted() {
            this.resetForm()
        },
        methods: {
            appointmentDateSelected(datetime) {
                this.$set(this.localBlowing, 'appointmentDate', momentTimezone(datetime).tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString())
            },
            onNewComment(e) {
                this.newComment = e
            },
            onTroublePhotoSelection(noOfSelectedPhotos) {
                this.selectedTroublePhotos = noOfSelectedPhotos
            },
            tabSelect(tab) {
                this.selectedTab = tab
            },
            switchEditMode(editMode) {
                if (!this.canEdit) {
                    return
                }
                this.resetForm()
                if (editMode) {
                    this.readOnly = false
                    this.clearable = true
                    this.editMode = true
                } else {
                    this.readOnly = true
                    this.clearable = false
                    this.editMode = false
                }
            },
            onUploadPhotoError(message) {
                this.setAlert(message, 'error')
            },
            onPhotoSelection(selectedPhotos) {
                this.selectedPhotos = selectedPhotos.length
            },
            resetForm() {
                this.localBlowing = this.assignment.blowing ? { ...this.assignment.blowing } : {}
                this.hasMalfunction = !!this.localBlowing.malfunction
                this.hasProdesmeusiDifference = !!this.localBlowing.prodesmeusiDifference
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            async editAssignment() {
                this.loading = true
                const coords = await geolocation.getCoordinates()
                if (!this.localBlowing.photos) {
                    this.localBlowing.photos = []
                }

                const malfunctionSection = this.$refs['malfunction-section'].getIssueValues()
                this.hasMalfunction = malfunctionSection.checked
                if (this.hasMalfunction) {
                    this.localBlowing.malfunction = this.localBlowing.malfunction || { photos: [] }
                    this.localBlowing.malfunction.newComment = malfunctionSection.newComment
                }

                try {
                    const uploadedPhotos = await this.$refs['image-section'].uploadPhotos()
                    this.localBlowing.photos = uploadedPhotos ? this.localBlowing.photos.concat(uploadedPhotos) : [ ...this.localBlowing.photos ]
                    if (this.hasMalfunction) {
                        const uploadedTroubleshootingPhotos = await this.$refs['malfunction-section'].uploadPhotos()
                        this.localBlowing.malfunction.photos = uploadedTroubleshootingPhotos ? this.localBlowing.malfunction.photos.concat(uploadedTroubleshootingPhotos) : [ ...this.localBlowing.malfunction.photos ]
                    }
                } catch (error) {
                    this.setAlert(error.message, 'error')
                    this.loading = false
                    return
                }
                const prodesmeusiDifferenceSection = this.$refs['prodesmeusi-difference-section'].getIssueValues()
                this.hasProdesmeusiDifference = prodesmeusiDifferenceSection.checked
                if (this.hasProdesmeusiDifference) {
                    this.localBlowing.prodesmeusiDifference = this.localBlowing.prodesmeusiDifference || {}
                    this.localBlowing.prodesmeusiDifference.newComment = prodesmeusiDifferenceSection.newComment
                }

                this.localBlowing.geolocation = coords
                this.localBlowing.newComment = this.newComment
                if (this.config.hasStorage) {
                    this.localBlowing.materialsRequested = this.$refs['material-selection'].proccessMaterialRequested()
                }
                assignmentService.updateAssignmentTab('blowing', this.assignment.id, { blowing: this.localBlowing }).then((response) => {
                    this.loading = false
                    this.photoUploadProgress = 0
                    this.$refs['comments'].clear()
                    this.$refs['malfunction-section'].clear()
                    this.setAlert('Η ενημέρωση της Εμφύσησης ήταν επιτυχημένη', 'success')
                    this.switchEditMode(false)
                    this.$emit('assignment-refresh')
                }).catch((error) => {
                    this.setAlert(error.response.data.message, 'error')
                    this.loading = false
                })
            },
            async onSubmit() {
                if (this.mode === 'edit') {
                    this.editAssignment()
                }
            }
        }

    }
</script>
<style scoped>
.form-group-fields {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
}

.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}
.edit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.edit-button-wrapper {
    display: flex;
    justify-content: flex-start;
}

.field.status {
    min-width: 270px;
    max-width: 20%;
}

.v-card {
    padding: 0.8rem;
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

.second-row {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-evenly;
    align-items: center;
    margin-top: 0.8rem;
}

</style>
